<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        block
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
      >
      <v-icon left dense>mdi-plus</v-icon>
        Add job
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title>Add new job</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text color="white" outlined light @click="save()">Save</v-btn>

          <v-btn text color="white" light @click="clearAndClose()"
            >Discard</v-btn
          ></v-toolbar-items
        >
      </v-toolbar>
      <v-card-text class="pa-0">
        <v-row class="ma-0">
          <v-col style="flex: 2" class="b-r">
            <v-form ref="newJobForm">
              <v-text-field
                v-model="externalUrl"
                label="External posting URL *"
                placeholder="Enter job url"
                outlined
                :rules="rules.externalUrl"
              ></v-text-field>
              <v-text-field
                v-model="title"
                label="Title *"
                placeholder="Enter job title"
                outlined
                :rules="rules.title"
              ></v-text-field>
              <v-select
                v-model="categories"
                :items="categoryItems"
                label="Categories *"
                multiple
                chips
                outlined
                dense
                item-text="name"
                item-value="id"
                :menu-props="{ offsetY: true }"
                :rules="rules.categories"
              ></v-select>
              <v-combobox
                v-model="tags"
                :items="tagItems"
                label="Tags"
                multiple
                chips
                outlined
                dense
              ></v-combobox>

              <!-- <v-text-field
                required
                v-model="organization"
                label="Organization"
                placeholder="Enter the name of the organization"
                outlined
              ></v-text-field> -->

              <h3>Employer details</h3>

              <v-combobox
                  v-model="selectedEmployer"
                  :items="getEmployers"
                  label="Employer name *"
                  placeholder="Select existing or create a new organisation"
                  outlined
                  item-text="name"
                  :rules="rules.selectedEmployer"
                ></v-combobox>

              <v-text-field
                  v-model="employer.externalUrl"
                  label="Link to website *"
                  placeholder="https://"
                  outlined
                  :rules="rules.employerExternalUrl"
                ></v-text-field>
                <v-text-field
                  v-model="employer.careersUrl"
                  label="Link to careers page *"
                  placeholder="https://"
                  outlined
                  :rules="rules.employerCareersUrl"
                ></v-text-field>
                <v-text-field
                  v-model="employer.imageUrl"
                  label="Logo URL *"
                  placeholder="https://"
                  outlined
                  :rules="rules.employerImageUrl"
                ></v-text-field>

              <h3>Job details</h3>

              <v-text-field
                v-model="city"
                label="City *"
                placeholder="Enter city or cities"
                outlined
                :rules="rules.city"
              ></v-text-field>
              <v-select
                v-model="area"
                :items="areaItems"
                label="Region *"
                outlined
                :menu-props="{ offsetY: true }"
                :rules="rules.area"
              ></v-select>
              <v-text-field
                v-model="country"
                label="Country"
                placeholder="Enter country"
                outlined
              ></v-text-field>

              <v-menu
                v-model="publishMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="publish"
                    label="Job posting publish date *"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    :rules="rules.publish"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="publish"
                  @input="publishMenu = false"
                ></v-date-picker>
              </v-menu>

              <v-menu
                v-model="expiresMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="expires"
                    label="Job posting expiry date *"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    :rules="rules.expires"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="expires"
                  @input="expiresMenu = false"
                ></v-date-picker>
              </v-menu>

              <v-textarea
                label="Job description *"
                placeholder="Enter job description"
                outlined
                v-model="description"
                :rules="rules.description"
              >
              </v-textarea>
            </v-form>
          </v-col>
          <v-col style="flex: 3; position: relative">
            <iframe
              :src="externalUrl"
              style="
                width: 100%;
                height: 100%;
                border: 4px solid rgba(0, 0, 0, 0.2);
                box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.2);
                border-radius: 10px;
              "
            >
            </iframe>
            <div
              style="
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
                font-size: 0.8rem;
                position: absolute;
                top: 0px;
                righ: 0px;
                display: block;
                padding: 0.5rem 1rem;
                background: white;
                border-radius: 6px;
              "
            >
              URL PREVIEW
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { cityToLocation } from '../utils';

export default {
  data() {
    return {
      dialog: false,
      publishMenu: false,
      expiresMenu: false,
      externalUrl: null,
      categories: null,
      tags: null,
      area: null,
      city: null,
      description: '',
      title: '',
      // organization: null,
      employer: {
        name: '',
        imageUrl: '',
        externalUrl: '',
        careersUrl: '',
      },
      imageUrl: '',
      country: 'Finland',
      publish: new Date().toISOString().substr(0, 10),
      expires: '',
      rules: {},
    };
  },
  watch: {
    city: function () {
      const location = cityToLocation(this.city);
      this.area = location.area;
      this.country = location.country ? location.country : 'Finland';
    },
  },
  mounted(){
    this.$store.dispatch('dispatchGetEmployers');
  },
  computed: {
    categoryItems() {
      return (this.$store.state.categoriesWithDetails || []).map((cat) => {
        const category = { ...cat, confidence: 1 };
        delete category.keywords;
        delete category.imageUrl;
        delete category.popularity;
        return category;
      });
    },
    tagItems() {
      return this.$store.state.tags || [];
    },
    areaItems() {
      const areas = (this.$store.state.mapData || []).map((area) => area.name);
      return areas;
    },
    getEmployers() {
      return (this.$store.state.employers && this.$store.state.employers.employers) || [];
    },
    selectedEmployer: {
      get: function () {
        return this.employer;
      },
      set: function (value) {
        if(
            typeof(value) == 'object'
            && value != null
            && value != undefined
        ){
          // Existing employer
          this.employer = value;
          delete this.employer.id;
        }
        else{
          // New employer
          this.employer.name = value;
          this.employer.source = 'jobsinfinland.fi-v1.0'
        }
      }
    }
  },
  methods: {
    jobData() {
      // if same date, publish now, i.e., use current time
      // otherwise, use start of the day
      let publish = this.publish ? this.publish + 'T00:00:00.000Z' : null;
      // same day
      if ( publish &&
           publish.split('T')[0] === new Date(Date.now()).toISOString().split('T')[0] )
        publish = new Date(Date.now()).toISOString();

      const res = {
        // id: this.title.toLowerCase(),
        title: this.title,
        description: this.description,
        imageUrl: this.imageUrl,
        externalUrl: this.externalUrl,
        // organization: this.organization,
        employer: {
          // id: "",
          name: this.employer.name,
          imageUrl: this.employer.imageUrl,
          externalUrl: this.employer.externalUrl,
          careersUrl: this.employer.careersUrl,
          location: {
            city: this.city,
            area: this.area,
            country: this.country,
          },
          source: 'jobsinfinland.fi-v1.0'
        },

        location: {
          city: this.city,
          area: this.area,
          country: this.country,
        },

        source: {
          apiId: 'test-api-v1.0',
          documentId: 'test-job-' + Math.round(Math.random() * 1000),
          firstSeen: new Date(Date.now()).toISOString(),
          lastSeen: new Date(Date.now()).toISOString(),
          contactEmail: ''
        },

        schedule: {
          publish,
          expire: this.expires ? this.expires + 'T23:59:59.000Z' : null,
        },

        clustering: {
          categories: this.categories
            ? this.categories.map((category) => {
                return  this.categoryItems.find(cat => cat.id == category);
              })
            : [],
          tags: this.tags
            ? this.tags.map((tag) => {
                return { id: tag.toLowerCase(), confidence: 1 };
              })
            : [],
          position: {
            x: 0,
            y: 0
          }
        },
        status: {
          publicationStatus: 'published', // pending, published, expired, hidden
          reviewStatus: 'human',
          hiddenBecause: {
            finnishRequired: false
          },
          reportedBecause: {
            finnishRequired: 0,
            wrongCategory: 0
          },
          transformations: {
            machineHidden: false,
            machineTranslated: false
          }
        },
        // expires
      };
      return res;
    },
    save() {
      const data = this.jobData();
      console.log(data);
      // Update rules and validate
      this.rules = {
        externalUrl: [v => !!v || 'Required'],
        title: [v => !!v || 'Required'],
        categories: [v => !!v || 'Required'],
        selectedEmployer: [v => !!v || 'Required'],
        employerExternalUrl: [v => !!v || 'Required'],
        employerCareersUrl: [v => !!v || 'Required'],
        employerImageUrl: [v => !!v || 'Required'],
        city: [v => !!v || 'Required'],
        area: [v => !!v || 'Required'],
        publish: [v => !!v || 'Required'],
        expires: [v => !!v || 'Required'],
        description: [v => !!v || 'Required'],
      };
      this.$nextTick(() => {
        if (this.$refs.newJobForm.validate()) {
          this.$store
            .dispatch('dispatchPostAdminJob', { jobData: data })
            .then((responseData) => {
              this.$emit('jobCreated', responseData);
              this.clearAndClose();
            })
            .catch((error) => {
              console.log(error);
              this.$store.dispatch('commitSnackbar',
                {
                  show: true,
                  message: 'Failed to create job. Please try again.',
                  timeout: 4000,
                  color: 'error',
                });
            });
        }
      });
    },
    clearAndClose() {
      this.$refs.newJobForm.reset();
      this.dialog = false;
    },
  },
};
</script>
